import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const getMultipartHeaders = () => ({
  "Content-Type": "multipart/form-data",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
});

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const uploadMedia = async (formData) => {
  return await axiosInstance.post("media-library/upload", formData, {
    headers: getMultipartHeaders(),
  });
};

export const importExternalMedia = async (payload) => {
  return await axiosInstance.post("media-library/import-external", payload, {
    headers,
  });
};

export const searchExternalMedia = async (params) => {
  return await axiosInstance.get("media-library/search-external", {
    headers,
    params,
  });
};

export const getMediaPicker = async (params) => {
  return await axiosInstance.get("media-library/picker", {
    headers,
    params,
  });
};

export const getRecentUploads = async () => {
  return await axiosInstance.get("media-library/recent-uploads", { headers });
};

export const getMediaById = async (id) => {
  const response = await axiosInstance.get(`media-library/get/${id}`, {
    headers,
  });
  return response.data.result;
};

export const getMediaProviders = async () => {
  return await axiosInstance.get("media-library/providers", { headers });
};

export const updateMediaMetadata = async (payload) => {
  return await axiosInstance.put("media-library/update-metadata", payload, {
    headers,
  });
};

export const bulkUpdateMediaMetadata = async (payload) => {
  return await axiosInstance.post(
    "media-library/bulk-update-metadata",
    payload,
    { headers }
  );
};

export const deleteMedia = async (id) => {
  return await axiosInstance.delete(`media-library/delete/${id}`, { headers });
};

export const bulkDeleteMedia = async (payload) => {
  return await axiosInstance.post("media-library/bulk-delete", payload, {
    headers,
  });
};

export const addMediaUsage = async (payload) => {
  return await axiosInstance.post("media-library/usages/add", payload, {
    headers,
  });
};

export const getMediaUsages = async (mediaId) => {
  return await axiosInstance.get(`media-library/usages/get/${mediaId}`, {
    headers,
  });
};

export const deleteMediaUsage = async (id) => {
  return await axiosInstance.delete(`media-library/usages/delete/${id}`, {
    headers,
  });
};
